import { type PaymentBrand, PaymentMethodIcon } from '../../components/icons/payment';

const PAYMENT_BRANDS: PaymentBrand[] = ['paypal', 'visa', 'mastercard', 'sepa'];

export function FooterPaymentIcons() {
  return (
    <div className="grid grid-cols-4 gap-3 sm:grid-cols-2">
      {PAYMENT_BRANDS.map((brand) => (
        <PaymentMethodIcon key={brand} brand={brand} className="size-12" />
      ))}
    </div>
  );
}
